const environmentResolver = host => {
	switch (host) {
		case 'localhost:3100':
		case 'localhost':
			return 'local';

		case 'apppreview-feature.sorted.com':
		case 'app-dev-01.sortedgroup.dev':
		case 'app-dev-02.sortedgroup.dev':
		case 'app-dev-03.sortedgroup.dev':
		case 'app-dev-04.sortedgroup.dev':
		case 'app-dev-05.sortedgroup.dev':
		case 'app-dev-06.sortedgroup.dev':
		case 'app-dev-07.sortedgroup.dev':
			return 'feature';

		case 'apppreview-preprod.sorted.com':
			return 'preprod';

		case 'sandbox-portal.sorted.com':
			return 'sandbox';

		case 'performance-portal.sortedgroup.dev':
			return 'performance';

		default:
			return 'production';
	}
};

export default environmentResolver;
